/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

const FcsPermissionPrintReceiptV2 = {
  permission_print_receipt_v2_enable: new FcsFlag.Flag(false)
}

export const FlagsPermissionPrintReceiptV2 = {
  ...FcsPermissionPrintReceiptV2
};

export function initFlagsPermissionPrintReceiptV2() {
  FcsFlag.register("featurePrintReceiptV2", FlagsPermissionPrintReceiptV2);
}
